import { useParams } from 'react-router-dom';
import { useAuth } from '../../shared/context';
import { TermSheetPage } from './Employees';
import { LenderTermSheetPage } from './Lenders';

export const TermSheets: React.FC = () => {
	var auth = useAuth();
	const { guid } = useParams<'guid'>();

	return auth.currentUser.isBankUser ? (
		<LenderTermSheetPage dataRoomGuid={guid} currentUser={auth.currentUser} />
	) : (
		<TermSheetPage dataRoomGuid={guid} currentUser={auth.currentUser} />
	);
};
